import { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Modal, ModalHeader, ModalBody, Button } from 'sfy-react';
import errorSymbol from '../assets/errorSymbol.svg'
import './modal.scss'
function ErrorModal(props) {
 const { error, showModal, closeModal, onClick } = props;

 return (
  <Modal showModal={showModal} closeModal={closeModal} className='pwa-req-success-modal' backdropClassName='brand-pp-backdrop'>
   <ModalHeader>
    <Row >
     <Col xs={12} className='error-modal-header'>
      <img src={errorSymbol} />
     </Col>
    </Row>
   </ModalHeader>
   <ModalBody>
      <Container fluid className="m-0 g-0" style={{ padding: '10px 0px 30px', height: "100%" }}>
       <Row>
       <Col xs={12} className='error-modal--desc'>
      <span>{error}
      </span>
      </Col>
        <Col xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
         <Button type='button'text="Ok" classes='pwa-continue-btn' 
          handleOnClick={onClick} >
         </Button>
        </Col>
       </Row>
      </Container>

   </ModalBody>

  </Modal>
 );
}
export default ErrorModal
